import React, { FC, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSignal, viewport } from "@telegram-apps/sdk-react";
import { TabBar } from "@/app/components/TabBar/TabBar";
import { useDebugFlag } from "@/app/useDebugFlag";
import cls from "./styles.module.scss";

export const App: FC = () => {
  const { pathname } = useLocation();
  const viewRef = useRef<HTMLDivElement>(null);
  const insetTop = useSignal(viewport.safeAreaInsetTop);
  const contentInsetTop = useSignal(viewport.contentSafeAreaInsetTop);
  const insetBottom = useSignal(viewport.safeAreaInsetBottom);

  useDebugFlag();

  // Смена вкладки — новый экран, скроллим к началу, как в прототипе.
  useEffect(() => {
    viewRef.current?.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <div
      className={cls.screen}
      style={{
        paddingTop: `${insetTop + contentInsetTop}px`,
        paddingBottom: `${insetBottom}px`,
      }}
    >
      <div className={cls.view} ref={viewRef}>
        <Outlet />
      </div>
      <TabBar />
    </div>
  );
};
